import React from 'react';
import _pick from 'lodash/pick';
import _startCase from 'lodash/startCase';
import moment from 'moment';

// Constants
import { LABEL_BY_STATUS } from 'constants/status';
import { FORMATS } from 'constants/date';

// Helpers
import { formattedDate } from 'helpers/common';

// Components
import StatusLabel from 'components/StatusLabel';

export const TAB_KEY = 'all';

const STATUSES = [
  'PRE_VIDEO_CALL',
  'VIDEO_CALL',
  'FAILED',
  'AGENT_REVIEWED',
  'AUDITOR_REVIEWED',
];

export const options = [
  { text: 'Auditor Name', value: 'auditorName' },
  { text: 'Agent Name', value: 'agentName' },
  { text: 'Mobile Number', value: 'mobile' },
];

export const COLUMN_ID = [
  {
    accessorKey: 'initiatedAt',
    header: 'Initiated At',
    cell: ({ initiatedAt }) => formattedDate(initiatedAt),
  },
  {
    accessorKey: 'customerName',
    header: 'Customer Name',
    cell: ({ customerName }) => customerName || '–',
  },
  {
    accessorKey: 'referenceId',
    header: 'Reference ID',
    cell: ({ referenceId }) => referenceId || '–',
  },
  {
    accessorKey: 'phone',
    header: 'Phone Number',
    cell: ({ phone }) => phone || '–',
  },
  {
    accessorKey: 'sessionDuration',
    header: 'Session Duration',
    cell: ({ sessionDuration }) => sessionDuration || '–',
  },
  { accessorKey: 'agent', header: 'Agent', cell: ({ agent }) => agent || '–' },
  {
    accessorKey: 'auditor',
    header: 'Auditor',
    cell: ({ auditor }) => auditor || '–',
  },
  {
    accessorKey: 'status',
    header: 'Status',
    cell: ({ status }) => <StatusLabel>{status}</StatusLabel>,
  },
];

export const labelByStatus = _pick(LABEL_BY_STATUS, STATUSES);

export const filtersConfig = {
  Status: {
    columns: 2,
    items: Object.keys(labelByStatus),
  },
};
